import React, { useCallback, useEffect, useState } from "react";
import { useParams, Link, useHistory } from "react-router-dom";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import { Card, Col, Row, Button } from "reactstrap";
import "../../assets/scss/style.css";
import Pagination, { bootstrap5PaginationPreset } from "react-responsive-pagination";
import { getPropertiesByUser } from "services/userServices";

const UserProperties = () => {
  const { userId } = useParams();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [listingData, setListingData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const perPage = 10;

  const fetchData = useCallback(async (pageNumber, pageSize) => {
    try {
      setLoading(true);
      const res = await getPropertiesByUser(userId, pageNumber, pageSize, "", "", "");
      const items = res?.data?.items || [];
      setListingData(Array.isArray(items) ? items : []);

      const explicitPages = Number(
        res?.data?.totalPages ||
          res?.data?.pageCount ||
          res?.data?.pages ||
          res?.data?.pagination?.totalPages ||
          0
      ) || 0;
      if (explicitPages > 0) {
        setTotalPages(explicitPages);
      } else {
        const totalRecords = Number(
          res?.data?.total ||
            res?.data?.totalCount ||
            res?.data?.count ||
            res?.data?.totalRecords ||
            res?.data?.totalListings ||
            res?.data?.pagination?.total ||
            0
        ) || 0;
        let pages = Math.ceil(totalRecords / perPage);
        if (pages < 1 && items.length > 0) pages = 1;
        setTotalPages(pages);
      }
    } catch (err) {
      console.error(err);
      setListingData([]);
      setTotalPages(0);
    } finally {
      setLoading(false);
    }
  }, [userId]);

  useEffect(() => {
    fetchData(currentPage, perPage);
  }, [fetchData]);

  const handlePageClick = (page) => {
    setCurrentPage(page);
    fetchData(page, perPage);
  };

  const handlePropertyClick = (propertyId) => {
    // Navigate to user property detail page
    history.push(`/admin/users/${userId}/properties/${propertyId}/details`, {
      fromPage: currentPage
    });
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row>
          <Col lg="12">
            <Card className="card-transparent">
              <div className="mb-3">
                <Row className="d-flex align-items-center">
                  <Col lg="6">
                    <h5 className=" text-color-gredient">User Properties</h5>
                  </Col>
                  <Col lg="6" className="d-flex justify-content-end gap-2">
                    <Link to="/admin/users" className="btn btn-light">Back to Users</Link>
                    <Link to={`/admin/users/${userId}/enquiries`} className="btn all-common-btn">View Enquiries</Link>
                  </Col>
                </Row>
              </div>
              <div className="table-responsive">
                <Table id="user-properties-table" className="table common-table table-nowrap table-bordered">
                  <Thead>
                    <Tr>
                      <Th>Sr No</Th>
                      <Th>Photo</Th>
                      <Th>Property Type</Th>
                      <Th>Description</Th>
                      <Th>City</Th>
                      <Th>Address</Th>
                      <Th>Total Rooms</Th>
                      <Th>Phone Number</Th>
                      <Th>Action</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {loading ? (
                      <Tr>
                        <Td colSpan="9">Loading ...</Td>
                      </Tr>
                    ) : listingData.length > 0 ? (
                      listingData.map((element, index) => (
                        <tr key={index}>
                          <td>{(currentPage - 1) * perPage + (index + 1)}</td>
                          <td>
                            <img 
                              src={element?.photos?.[0] || "/default.png"} 
                              alt="Property" 
                              style={{ width: "100px", height: "100px", objectFit: "cover" }}
                              onError={(e) => {
                                e.target.src = "/default.png";
                              }}
                            />
                          </td>
                          <td>{element?.listingType || "-"}</td>
                          <td style={{ maxWidth: "200px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                            {element?.description || "-"}
                          </td>
                          <td>{element?.city || "-"}</td>
                          <td style={{ maxWidth: "200px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                            {element?.address || "-"}
                          </td>
                          <td>{element?.total_rooms || "-"}</td>
                          <td>{element?.phone_number || "-"}</td>
                          <td>
                            <Button
                              color="primary"
                              size="sm"
                              onClick={() => handlePropertyClick(element._id || element.id)}
                              style={{ fontSize: "12px", padding: "4px 8px" }}
                            >
                              View Details
                            </Button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="9" className="text-center">No Records Found</td>
                      </tr>
                    )}
                  </Tbody>
                </Table>
              </div>

              <Row className="mt-2">
                <Col md={9}></Col>
                <Col md={3}>
                  <Pagination
                    {...bootstrap5PaginationPreset}
                    current={currentPage}
                    total={Math.max(1, totalPages)}
                    onPageChange={handlePageClick}
                    className="pagination justify-content-end gap-1"
                  />
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default UserProperties;


